const translation = {
  nav_home: "Начало",
  nav_contracts: "Контракты",
  nav_calculator: "Калькулятор",
  nav_analysts: "Аналитики",
  nav_benefits: "Преимущества",
  nav_about: "О нас",
  nav_contact: "Контакт",

  hero_badge: "СРОЧНАЯ ВОЗМОЖНОСТЬ",
  hero_title1: "ИРАНСКИЙ КРИЗИС",
  hero_title2: "ВАШ ШАНС",
  hero_title3: "НА ПРИБЫЛЬ",
  hero_subtitle: "20% мировой нефти заблокировано. Цены на Brent взлетают. Действуйте сейчас.",
  hero_cta1: "СМОТРЕТЬ КОНТРАКТЫ",
  hero_cta2: "Узнать больше",

  contracts_title: "ВЫБЕРИТЕ ВАШ КОНТРАКТ",
  contracts_subtitle: "Три уровня инвестиций с гарантированной доходностью",
  contract_basic: "БАЗОВЫЙ",
  contract_popular: "САМЫЙ ПОПУЛЯРНЫЙ",
  contract_pro: "ПРОФЕССИОНАЛЬНЫЙ",
  contract_investment: "Инвестиция",
  contract_profit: "ВАША ПРИБЫЛЬ",
  contract_total: "ИТОГО К ПОЛУЧЕНИЮ",
  contract_yield: "ДОХОДНОСТЬ",
  contract_start: "НАЧАТЬ",
  contract_choose: "ВЫБРАТЬ СЕЙЧАС",
  contract_maximize: "МАКСИМИЗИРОВАТЬ",
  contract_disclaimer: "* Доходность основана на текущих рыночных условиях и исторических данных. Инвестиции несут риск.",

  calc_title: "КАЛЬКУЛЯТОР ЗАРАБОТКА",
  calc_subtitle: "Посмотрите, сколько вы можете заработать с каждым контрактом",
  calc_investment: "Ваша инвестиция:",
  calc_yield: "Доходность:",
  calc_profit: "Ваша прибыль:",
  calc_total: "Итого получите:",
  calc_basic_label: "Базовый уровень",
  calc_popular_label: "Популярный выбор",
  calc_max_label: "Максимальная прибыль",
  calc_double: "Вы удваиваете свои деньги!",
  calc_2_5: "Вы получаете в 2.5 раза больше!",
  calc_3x: "Вы получаете более чем в 3 раза больше!",
  calc_best: "ЛУЧШЕЕ ПРЕДЛОЖЕНИЕ",
  calc_cta_title: "Чем больше инвестируете, тем больше зарабатываете!",
  calc_cta_sub: "Наши контракты разработаны для максимизации вашей прибыли в условиях текущего кризиса",
  calc_cta_btn: "НАЧАТЬ ЗАРАБАТЫВАТЬ",

  analysts_badge: "НАШ КОЛЛЕКТИВ",
  analysts_title: "Эксперты с",
  analysts_title_accent: "эксклюзивным доступом",
  analysts_subtitle: "Эти специалисты предоставляют вам доступ к лучшим нефтяным контрактам и ведут вас к максимальной прибыли.",
  analyst_contact: "СВЯЗАТЬСЯ С",

  analyst1_name: "Николай Илиев",
  analyst1_role: "Главный финансовый аналитик",
  analyst1_desc: "Николай — ведущий эксперт в области нефтяных инвестиций с более чем 15-летним опытом. Специализируется на анализе геополитических рисков и их влиянии на цены сырой нефти.",
  analyst1_exp: "15+ лет опыта",
  analyst1_clients: "300+ клиентов",

  analyst2_name: "Димитър Стоянов",
  analyst2_role: "Старший аналитик нефтяных рынков",
  analyst2_desc: "Димитър — специалист в техническом анализе нефтяных рынков. Разрабатывает стратегии для максимизации доходности в условиях волатильных рынков.",
  analyst2_exp: "12+ лет опыта",
  analyst2_clients: "250+ клиентов",

  analyst3_name: "Иван Стоянов",
  analyst3_role: "Аналитик энергетических рынков",
  analyst3_desc: "Иван Стоянов фокусируется на анализе глобальных энергетических рынков. Специализируется на выявлении инвестиционных возможностей в кризисных ситуациях.",
  analyst3_exp: "10+ лет опыта",
  analyst3_clients: "200+ клиентов",

  analyst4_name: "Миглена Станева",
  analyst4_role: "Финансовый консультант",
  analyst4_desc: "Миглена — сертифицированный финансовый консультант с богатым опытом управления инвестиционными портфелями. Предоставляет персонализированные стратегии для каждого клиента.",
  analyst4_exp: "8+ лет опыта",
  analyst4_clients: "180+ клиентов",

  analyst5_name: "Николас Станев",
  analyst5_role: "Аналитик сырьевых рынков",
  analyst5_desc: "Николас Станев — специалист в анализе сырьевых рынков с фокусом на нефть и природный газ. Разрабатывает точные прогнозы движения цен.",
  analyst5_exp: "11+ лет опыта",
  analyst5_clients: "220+ клиентов",

  analyst6_name: "Стефан Минчев",
  analyst6_role: "Инвестиционный стратег",
  analyst6_desc: "Стефан Минчев — опытный инвестиционный стратег, специализирующийся в нефтяном секторе. Помогает клиентам достичь максимальной доходности через оптимизированные инвестиционные стратегии.",
  analyst6_exp: "9+ лет опыта",
  analyst6_clients: "190+ клиентов",

  benefits_title: "ПОЧЕМУ ВЫБИРАЮТ НАС",
  benefits_subtitle: "Преимущества инвестирования в нефтяные контракты Brent",
  benefit1_title: "Высокая доходность",
  benefit1_desc: "Получайте от 100% до 210% прибыли благодаря текущей геополитической ситуации и росту цен на нефть",
  benefit2_title: "Безопасность",
  benefit2_desc: "Все транзакции защищены, контракты юридически оформлены, ваши инвестиции под надёжной защитой",
  benefit3_title: "Экспертная поддержка",
  benefit3_desc: "Команда из 6 сертифицированных финансовых аналитиков с многолетним опытом работы на нефтяном рынке",
  benefit4_title: "Быстрый старт",
  benefit4_desc: "Простой процесс регистрации и активации контракта. Начните зарабатывать уже сегодня",
  benefit5_title: "Глобальный рынок",
  benefit5_desc: "Доступ к международным нефтяным контрактам Brent на институциональном уровне",
  benefit6_title: "Прозрачность",
  benefit6_desc: "Регулярные отчёты, аналитика и полная прозрачность всех операций и результатов",

  about_map_title: "ОРМУЗСКИЙ ПРОЛИВ ЗАБЛОКИРОВАН",
  about_map_sub: "мировой нефти",
  about_title: "КРИЗИС СОЗДАЁТ ВОЗМОЖНОСТИ",
  about_p1: "Конфликт в Иране привёл к блокировке Ормузского пролива — критического маршрута, через который проходит 20% мировых поставок нефти.",
  about_p2: "Это вызвало резкий рост цен на нефть Brent, создавая уникальную возможность для инвесторов реализовать значительную прибыль через специализированные нефтяные контракты.",
  about_p3: "Геополитическая нестабильность продолжает влиять на рынок, и эксперты прогнозируют дальнейший рост цен в ближайшие месяцы.",
  about_cta: "УЗНАТЬ СТРАТЕГИЮ",

  contact_title: "ГОТОВЫ НАЧАТЬ?",
  contact_subtitle: "Свяжитесь с Николаем Илиевым и начните свой инвестиционный путь сегодня. Ограниченное количество мест для новых инвесторов.",
  contact_website: "Официальный сайт",
  contact_hours: "Рабочее время",
  contact_hours_weekdays: "Понедельник – Пятница: 9:00 – 18:00",
  contact_hours_saturday: "Суббота: 10:00 – 14:00",
  contact_security: "Безопасность и доверие",
  contact_security_desc: "Все транзакции защищены и конфиденциальны",
  contact_team_title: "Выберите своего аналитика",
  contact_team_sub: "6 лицензированных финансовых специалистов",
  contact_team_desc: "Ознакомьтесь с нашей командой экспертов и выберите аналитика, с которым хотите работать. Каждый из них предлагает персональный подход и прямой доступ к нефтяным контрактам Brent.",
  contact_btn: "СВЯЗАТЬСЯ С НИКОЛАЕМ ИЛИЕВЫМ",
  contact_btn_sub: "Главный финансовый аналитик с 15+ годами опыта",
  contact_choose_analyst_btn: "ВЫБРАТЬ СВОЕГО АНАЛИТИКА",
  contact_choose_analyst_sub: "6 лицензированных специалистов — найдите своего личного эксперта",
  contact_stat_analysts: "Аналитиков",
  contact_stat_clients: "Клиентов",
  contact_stat_yield: "Макс. доходность",

  footer_tagline: "Не упустите возможность воспользоваться текущей рыночной ситуацией.",
  footer_nav: "НАВИГАЦИЯ",
  footer_social: "СВЯЗАТЬСЯ",
  footer_contact: "КОНТАКТ",
  footer_contact_desc: "Для получения дополнительной информации и прямой связи с Николаем Илиевым:",
  footer_rights: "© 2026 Brent Oil Investment. Все права защищены.",
  footer_terms: "Условия использования",
  footer_privacy: "Конфиденциальность",
  footer_disclaimer: "Инвестиции в нефтяные контракты несут риск. Прошлые результаты не гарантируют будущую прибыль. Пожалуйста, инвестируйте ответственно.",
};

export default translation;
